import { ContextMenu as _ContextMenu } from './context-menu';
import { PopoverContainer } from './context-menu.popover-container';
import type { PopoverContainerProps } from './context-menu.popover-container';

const ContextMenu = Object.assign(_ContextMenu, {
  PopoverContainer,
});

export { ContextMenu };
export type { PopoverContainerProps };
